import { render, staticRenderFns } from "./ComponentServicesTabStats.vue?vue&type=template&id=8f5b46e2&scoped=true&"
import script from "./ComponentServicesTabStats.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentServicesTabStats.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentServicesTabStats.vue?vue&type=style&index=0&id=8f5b46e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5b46e2",
  null
  
)

export default component.exports